import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import Link from '../../../elements/Link';
import Text from '../../../elements/Text';
import { TextProps } from '../../../elements/Text/Text';
import Title from './Title';

interface Props {
  showTitle?: boolean;
  showAddress?: boolean;
  showDirections?: boolean;
  address?: string;
  directionsLink?: string;
  titleStyles?: React.ComponentPropsWithoutRef<typeof Title>;
  addressStyles?: TextProps;
  directionsStyles?: TextProps;
}

function Address({
  showTitle = true,
  showDirections = true,
  showAddress = true,
  address = '',
  directionsLink = '',
  titleStyles,
  addressStyles,
  directionsStyles,
  ...props
}: StyledProps<Props>) {
  const { translate } = useContext(Context);
  return (
    <Box
      className="station-item-address"
      display="flex"
      flexDirection="column"
      paddingBottom="2"
      {...props}
    >
      {showTitle && <Title {...titleStyles} />}
      {showAddress && (
        <Box display="flex">
          <Text {...addressStyles}>{address}</Text>
        </Box>
      )}
      {showDirections && directionsLink && (
        <Box>
          <Link href={directionsLink} target="_blank" {...directionsStyles}>
            {translate('cmp-bus-directory-map-directions', 'Get Directions')}
          </Link>
        </Box>
      )}
    </Box>
  );
}

Address.componentName = 'Address';

export default Address;
